<div class="popup-overlay">
    <div class="popup-content" [style.width.px]="type === 'approve' ? 478 : 616" [style.height.px]="type === 'approve' ? 176 : 421">
        <div class="popup-header">
            <h2>{{ title }}</h2>
        </div>

        <!-- Reject Popup Body -->
        @if (type === "reject") {
            <div class="popup-body">
                <div class="form-group">
                    <label for="rejection-reason" class="required-label">{{ "addReasonForRejection" | translate }}</label>
                    <select id="rejection-reason" class="rejection-dropdown" [value]="selectedRejectionOption" (change)="onReasonSelect($event)">
                        <option value="">{{ "selectReason" | translate }}</option>
                        <option value="Social Category does not match the one on paper.">
                            {{ "socialCategoryMismatch" | translate }}
                        </option>
                        <option value="Incomplete documentation">{{ "incompleteDocumentation" | translate }}</option>
                        <option value="Information mismatch">{{ "informationMismatch" | translate }}</option>
                        <option value="Other">{{ "other" | translate }}</option>
                    </select>
                </div>
                <div class="form-group">
                    <label for="custom-reason">{{ "remarkOptional" | translate }}</label>
                    <textarea
                        id="custom-reason"
                        [placeholder]="'enterRejectionReason' | translate"
                        class="custom-reason-textarea"
                        [value]="customRemark"
                        (input)="onCustomReasonInput($event)"
                    ></textarea>
                </div>
            </div>
        }

        <div class="popup-footer">
            <button [class]="type === 'approve' ? 'btn-approve' : 'btn-reject'" (click)="onConfirm()" [disabled]="isProcessing">
                @if (!isProcessing) {
                    <span>
                        {{ type === "approve" ? ("yes" | translate) : ("reject" | translate) }}
                    </span>
                }
                @if (isProcessing) {
                    <span>
                        {{ type === "approve" ? ("approving" | translate) : ("rejecting" | translate) }}
                    </span>
                }
            </button>
            <button class="btn-cancel" (click)="onCancel()" [disabled]="isProcessing">
                {{ "cancel" | translate }}
            </button>
        </div>
    </div>
</div>
